import types from '../mutation-types';
import BulkActionsAPI from '../../api/bulkActions';

export const state = {
  selectedConversationIds: [],
  selectedContactIds: [],
  selectionMode: 'manual',
  excludedConversationIds: [],
  matchingCount: 0,
  matchingCountTruncated: false,
  uiFlags: {
    isUpdating: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getSelectedConversationIds(_state) {
    return _state.selectedConversationIds;
  },
  getSelectedContactIds(_state) {
    return _state.selectedContactIds;
  },
  getSelectionMode(_state) {
    return _state.selectionMode;
  },
  getExcludedConversationIds(_state) {
    return _state.excludedConversationIds;
  },
  getMatchingCountTruncated(_state) {
    return _state.matchingCountTruncated;
  },
  getMatchingCount(_state) {
    return _state.matchingCount;
  },
  isAllMatchingSelected(_state) {
    return _state.selectionMode === 'all_matching';
  },
};

export const actions = {
  process: async function processAction({ commit }, payload) {
    commit(types.SET_BULK_ACTIONS_FLAG, { isUpdating: true });
    try {
      const response = await BulkActionsAPI.create(payload);
      return response?.data;
    } catch (error) {
      const wrapped = new Error(error);
      wrapped.response = error?.response;
      throw wrapped;
    } finally {
      commit(types.SET_BULK_ACTIONS_FLAG, { isUpdating: false });
    }
  },
  setSelectedConversationIds({ commit }, id) {
    commit(types.SET_SELECTED_CONVERSATION_IDS, id);
  },
  setAllMatchingSelection({ commit }, { count, truncated }) {
    commit(types.SET_ALL_MATCHING_SELECTION, { count, truncated });
  },
  excludeFromSelection({ commit }, id) {
    commit(types.EXCLUDE_FROM_SELECTION, id);
  },
  includeInSelection({ commit }, id) {
    commit(types.INCLUDE_IN_SELECTION, id);
  },
  clearSelectionMode({ commit }) {
    commit(types.CLEAR_SELECTION_MODE);
  },
  setSelectedContactIds({ commit }, ids) {
    commit(types.SET_SELECTED_CONTACT_IDS, ids);
  },
  addSelectedContactIds({ commit }, ids) {
    commit(types.ADD_SELECTED_CONTACT_IDS, ids);
  },
  removeSelectedContactIds({ commit }, ids) {
    commit(types.REMOVE_SELECTED_CONTACT_IDS, ids);
  },
  clearSelectedContactIds({ commit }) {
    commit(types.CLEAR_SELECTED_CONTACT_IDS);
  },
  removeSelectedConversationIds({ commit }, id) {
    commit(types.REMOVE_SELECTED_CONVERSATION_IDS, id);
  },
  clearSelectedConversationIds({ commit }) {
    commit(types.CLEAR_SELECTED_CONVERSATION_IDS);
  },
};

export const mutations = {
  [types.SET_BULK_ACTIONS_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_SELECTED_CONVERSATION_IDS](_state, ids) {
    // Check if ids is an array, if not, convert it to an array
    const idsArray = Array.isArray(ids) ? ids : [ids];

    // Concatenate the new IDs ensuring no duplicates
    _state.selectedConversationIds = [
      ...new Set([..._state.selectedConversationIds, ...idsArray]),
    ];
  },
  [types.REMOVE_SELECTED_CONVERSATION_IDS](_state, id) {
    _state.selectedConversationIds = _state.selectedConversationIds.filter(
      item => item !== id
    );
  },
  [types.CLEAR_SELECTED_CONVERSATION_IDS](_state) {
    _state.selectedConversationIds = [];
    _state.selectionMode = 'manual';
    _state.excludedConversationIds = [];
    _state.matchingCount = 0;
    _state.matchingCountTruncated = false;
  },
  [types.SET_ALL_MATCHING_SELECTION](_state, { count, truncated }) {
    _state.selectionMode = 'all_matching';
    _state.matchingCount = count;
    _state.matchingCountTruncated = truncated === true;
    _state.excludedConversationIds = [];
  },
  [types.EXCLUDE_FROM_SELECTION](_state, id) {
    _state.excludedConversationIds = [
      ...new Set([..._state.excludedConversationIds, id]),
    ];
  },
  [types.INCLUDE_IN_SELECTION](_state, id) {
    _state.excludedConversationIds = _state.excludedConversationIds.filter(
      item => item !== id
    );
  },
  [types.CLEAR_SELECTION_MODE](_state) {
    _state.selectionMode = 'manual';
    _state.excludedConversationIds = [];
    _state.matchingCount = 0;
    _state.matchingCountTruncated = false;
  },
  [types.SET_SELECTED_CONTACT_IDS](_state, ids) {
    _state.selectedContactIds = [...new Set([...ids])];
  },
  [types.ADD_SELECTED_CONTACT_IDS](_state, ids) {
    _state.selectedContactIds = [
      ...new Set([..._state.selectedContactIds, ...ids]),
    ];
  },
  [types.REMOVE_SELECTED_CONTACT_IDS](_state, ids) {
    const idsToRemove = Array.isArray(ids) ? ids : [ids];
    _state.selectedContactIds = _state.selectedContactIds.filter(
      id => !idsToRemove.includes(id)
    );
  },
  [types.CLEAR_SELECTED_CONTACT_IDS](_state) {
    _state.selectedContactIds = [];
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
